// the minus and plus divs are probably not yet available,
// So we listen to any click, and ony then look for the specific divs
document.addEventListener('DOMContentLoaded', function () {
  let timeout;

  document.body.addEventListener('click', function (event) {
    const input = event.target.parentNode.querySelector('input');
    const updateQbutton = document.querySelector(".cart-block--offcanvas-contents__update");

    const isMinusButton = event.target.matches('.cart-item-quantity-minus');
    const isPlusButton = event.target.matches('.cart-item-quantity-plus');

    if (!isMinusButton && !isPlusButton) {
      return;
    }

    if (isMinusButton) {
      input.stepDown(1);
    }

    if (isPlusButton) {
      input.stepUp(1);
    }

    input.dispatchEvent(new Event('change', {bubbles: true}));

    // If user clicks many times in succession, only send event once to update Backbone model values.
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      updateQbutton.dispatchEvent(new Event('click', {bubbles: true}));
    }, 500);
  });

});

